import { registerWidget, IWidgetDefinition, IWidgetSettings, IWidget, ISeria, IBaseSettings } from '../../common/core';
var template = require("./list.html");
var styles = require("./list.scss").toString();

export interface IListState {
}

export interface IListSettings extends IBaseSettings {
    template?: string,
    fields: string[],
    snippet?: {
        no_highlight_fields: string[], //if no highlight, and nothing here then return empty string
        highlight_fields_sort: string[], //add fields. to look for it; and if it is not here then alphabetical sort of keys (so its deterministic),
        lines?: number
    }
}

/**
* Settings for list widget
*/
export interface IListWidgetSettings extends IWidgetSettings<IListSettings, null> {
    type: "list"
}

class ListData {
    rows: ISeria[] = [];
    loading = true;

    /**
     * List labels
     */
    labels: { [id: string]: string; };

    constructor(public widget: IWidget<ListData, IListSettings, IListState>) {
        var labels = {
            // TODO: add labels
        };
        this.labels = { ...labels, ...this.widget.settings.labels };
    }

    capitalize(str: string) {
        if (!str) {
            return str;
        }

        var firstChar = str[0].toUpperCase();
        if (str.length == 1) {
            return firstChar;
        }
        return firstChar + str.substring(1);
    }

    getSnipetHtml(seria: ISeria) {
        var separator = '...';
        if (this.widget.settings.snippet) {
            var results = [];
            if (this.widget.settings.snippet.highlight_fields_sort) {
                for (let h of this.widget.settings.snippet.highlight_fields_sort) {
                    let fieldHighlights = seria.highlight && seria.highlight[h];
                    if (fieldHighlights) {
                        for (let fH of fieldHighlights) {
                            results.push(fH);
                        }
                    }
                }
            }

            if (!results.length) {
                if (this.widget.settings.snippet.no_highlight_fields) {
                    for (let h of this.widget.settings.snippet.no_highlight_fields) {
                        results.push(seria.getFieldHtmlWithHighlight(h, separator));
                    }
                }
            }

            if (results.length) {
                return results.join(separator)
            }
        }
        return '';
    }

    // always return html
    formatValue(seria: ISeria, field: string, separator: string = '...') {
        return seria.getFieldHtmlWithHighlight(field, separator);
    }

    trackByIndex(index) {
        return index;
    }

    beforeSearch() {
        this.loading = true;
        this.rows = [];
    }

    onData(response) {
        var rows;
        if (response.series && response.series.length) {
            rows = response.series.slice();
        } else {
            rows = [];
        }
        this.rows = rows;
        this.loading = false;
    }
}

var defaultLineClampNumbers = 3;
var defaultLineClampHeight = 1.3;
function generateLineClampStyles(lineClampNumbers, lineClampHeight) {
    return `
        .sj-rs-snippet {
            -webkit-line-clamp: ${lineClampNumbers};
            max-height: ${lineClampHeight * lineClampNumbers - 0.05}em;
            line-height: ${lineClampHeight}em;
        }
        .sj-rs-snippet:before {
            top: ${lineClampHeight * (lineClampNumbers - 1) + 0.1}em;
            height: ${lineClampHeight + 0.1}em;
        }
        .sj-rs-snippet:after {
            top: ${lineClampHeight * (lineClampNumbers - 1)}em;
            height: ${lineClampHeight}em;
        }
    `;
}

var widgetDefinition: IWidgetDefinition<ListData, IListSettings, null> = {
    init(widget) {
        widget.data = new ListData(widget);

    },
    getQuery(widget) { },
    getFields(widget) {
        return widget.settings.fields.join(',');
    },
    getFacets(widget) { },
    beforeSearch(widget) {
        widget.data.beforeSearch();
    },
    onData(widget, data) {
        widget.data.onData(data);
    },
    template: template,
    styles: (widget) => {
        var stls = styles;
        if (widget.settings.snippet && widget.settings.snippet.lines && defaultLineClampNumbers != widget.settings.snippet.lines) {
            stls += generateLineClampStyles(widget.settings.snippet.lines, defaultLineClampHeight);
        }
        return stls;
    }
};

export { ListData };
export default widgetDefinition;